<template>
  <div id="app">
    <cheader :pagefor="pagefor" v-if="header_show"></cheader>
    <router-view v-on:header="header" v-on:footer="footer"></router-view>
    <cfooter v-if="footer_show"></cfooter>
  </div>
</template>

<script>
import cheader from "../src/components/header";
import cfooter from "../src/components/footer";
export default {
  data() {
    return {
      pagefor: "1",
      screenWidth: document.body.clientWidth,
      header_show: true,
      footer_show: true,
    };
  },
  components: {
    cheader,
    cfooter,
  },
  created() {
    // if (this.screenWidth < 980) {
    //   this.getUrl();
    // }
    // if (window.location.pathname == "/") {
    //   this.pagefor = "0";
    // } else {
    //   this.pagefor = "1";
    // }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.path == "/") {
          this.pagefor = "0";
        } else {
          this.pagefor = "1";
        }
      },
      // 深度观察监听
      deep: true,
    },
    // screenWidth(newVal) {
    //   if (newVal <= 980) {
    //     this.getUrl();
    //   }
    // },
  },
  methods: {
    //是否显示头部
    header: function (bool) {
      this.header_show = bool;
    },
    //是否显示底部
    footer: function (bool) {
      this.footer_show = bool;
    },
    // getUrl() {
    //   var url = "";
    //   var wapUrl = "http://daoxi.com";
    //   var wap_url = wapUrl + "/pages";
    //   if (window.location.search) {
    //     url =
    //       wap_url +
    //       window.location.pathname +
    //       window.location.pathname +
    //       window.location.search;
    //   } else if (
    //     window.location.search == "" &&
    //     window.location.pathname == "/"
    //   ) {
    //     url = wapUrl;
    //   } else {
    //     url = wap_url + window.location.pathname + window.location.pathname;
    //   }
    //   window.location.href = url;
    // },
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      window.screenWidth = document.body.clientWidth;
      that.screenWidth = window.screenWidth;
    };
  },
};
</script>
